<div class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <nav aria-label="breadcrumb" class="theme-breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="'/'">{{'home' | translate}} <span
                                    class="mx-1">></span></a></li>
                        <li *ngFor="let breadCrumb of breadCrumbList ;  let isFirst = first ; let isLast = last">
                            <a *ngIf="isFirst"
                                [routerLink]="['/pages/category-support/', breadCrumb.id, breadCrumb.name.split(' ').join('-')]">{{
                                breadCrumb.name | translate }} <span class="mx-1">></span></a>
                            <a *ngIf="!isFirst && !isLast"
                                [routerLink]="['/pages/support-category-page/category/', breadCrumb.id, breadCrumb.name.split(' ').join('-')]">{{
                                breadCrumb.name | translate }} <span class="mx-1">></span></a>
                            <a *ngIf="isLast && articleName"
                                [routerLink]="['/pages/support-category-page/category/', breadCrumb.id, breadCrumb.name.split(' ').join('-')]">{{
                                breadCrumb.name | translate }} <span class="mx-1">></span></a>
                            <a *ngIf="isLast && !articleName">
                                {{ breadCrumb.name | translate }}
                            </a>
                        </li>
                        <li>
                            <a *ngIf="articleName">
                                {{ articleName | translate }}
                            </a>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>

<section>

    <div class="container">
        <div class="row">
            <div class="col-md-3">
                <div class="fixed-overlay" [class.fixed-overlay-open]="showSideBar" (click)="hideSideBar()">

                </div>
                <div class="article-container" [class.article-sidebar-open]="showSideBar"
                    *ngIf="!loadingSupportCategoryAndPageById else noloadingSupportCategoryAndPageById">
                    <div class="cursor-pointer col-sm-12 sidebar-control sidebar-control-close" (click)="hideSideBar()"
                        *ngIf="!loadingSupportCategoryAndPageById">
                        <mat-icon>close</mat-icon>
                        <h4>{{'menu category'|translate}}</h4>
                    </div>
                    <div class="position-relative container-input article-input ">

                        <mat-icon class="search-icon" [ngStyle]="!isDropdownVisible ? 
                {'display': 'block', 'left': commonService.isRtl ? '10px' : 'auto', 'right': commonService.isRtl ? 'auto' : '10px'} : 
                {'display': 'none'}">search</mat-icon>
                        <mat-icon [ngStyle]="isDropdownVisible ? 
                {'display': 'block', 'left': commonService.isRtl ? '10px' : 'auto', 'right': commonService.isRtl ? 'auto' : '10px'} : 
                {'display': 'none'}" class="search-icon search-position" (click)="clearInputSearch()">close</mat-icon>
                        <input #searchE type="text" class="form-control" [placeholder]="'search for'|translate"
                            [ngStyle]="{'padding-left': commonService.isRtl ? '35px' : '10px','padding-right': commonService.isRtl ? '10px' : '35px'}"
                            [(ngModel)]="searchData" (input)="getSearchSupportPage(searchE.value)"
                            (focus)="getSearchSupportPage(searchE.value)">
                        <div class="shadow search-dropdown" *ngIf="isDropdownVisible">
                            <app-search-drop [loadingSearch]="loadingSearch"
                                [searchList]="searchList"></app-search-drop>
                        </div>
                    </div>
                    <div class="my-4 category-support-container">
                        <div class="icon-title-container" *ngFor="let item of mainCategories let iMtoggle=index">
                            <div class="cursor-pointer" (click)="toggleMainCat(iMtoggle)">
                                <div class="icon-title-item">
                                    <div class="icon-title">
                                        <img [src]="item.img ? imgPath+item.img : 'assets/images/product/placeholder.jpg'"
                                            class="img-fluid" alt="defaultImage"
                                            (error)="handleImageError($event.target)" style="width: 20px;">
                                        <p>{{item.name}}</p>
                                    </div>
                                    <div class="add-rounded">
                                        <mat-icon *ngIf="!toggleMain[iMtoggle]">add</mat-icon>
                                        <mat-icon *ngIf="toggleMain[iMtoggle]">remove</mat-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="sub-container" *ngIf="toggleMain[iMtoggle]">
                                <div class="sub-category" *ngFor="let itemSub of item.sub let iStoggle=index">
                                    <div class="cursor-pointer" (click)="toggleSubCat(iMtoggle,iStoggle)">
                                        <div class="icon-title-item">
                                            <div class="icon-title">
                                                <mat-icon *ngIf="!toggleSub[iMtoggle][iStoggle]">add</mat-icon>
                                                <mat-icon *ngIf="toggleSub[iMtoggle][iStoggle]">remove</mat-icon>

                                                <p>{{itemSub.name}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sub-container" *ngIf="toggleSub[iMtoggle][iStoggle]">
                                        <div class="sub-category" *ngFor="let itemSubSub of itemSub.article">
                                            <div class="icon-title-item">
                                                <div class="cursor-pointer icon-title"
                                                    (click)="getSupportPageByIdAndBreadCrumb(itemSubSub.id,itemSubSub.title)">
                                                    <p [ngClass]="{'active-title': isActiveBreadcrumb(itemSubSub.id)}">
                                                        {{itemSubSub.title}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noloadingSupportCategoryAndPageById>
                    <div class="my-5 all d-flex justify-content-center align-items-center">
                        <img src="assets/images/loader.gif">
                    </div>

                </ng-template>
            </div>
            <div class="cursor-pointer col-sm-12 sidebar-control" (click)="openSideBar()"
                *ngIf="!loadingSupportCategoryAndPageById">
                <mat-icon>fullscreen</mat-icon>
                <h4>{{'menu category'|translate}}</h4>
            </div>
            <div class="col-md-9" *ngIf="mode=='article'&&!loadingSupportCategoryAndPageById">
                <div class="article-content">
                    <div *ngIf="!loadingSupportPageById else noloadingSupportPageById">
                        <h3>{{articleData?.title}}</h3>
                        <div [innerHTML]="articleData?.description | sanitizeHtmlPages:'html'"
                            class="article-content-api">

                        </div>
                    </div>
                    <ng-template #noloadingSupportPageById>
                        <div class="my-5 all d-flex justify-content-center align-items-center">
                            <img src="assets/images/loader.gif">
                        </div>
                    </ng-template>
                </div>
            </div>

        </div>

    </div>
</section>

<ngx-json-ld *ngIf="  breadcrumbSchema
 && breadcrumbSchema['itemListElement'].length >0"
    [json]="breadcrumbSchema"></ngx-json-ld>